<script>
import moment from 'moment'
import {
  RexInput,
  RexDate,
  RexEditor,
  RexSelect,
  RexTime
} from '@/components/views/rexFieldsV2'

export default {
  name: 'events-edit-form',
  components: {
    RexInput,
    RexDate,
    RexEditor,
    RexSelect,
    RexTime
  },
  data: () => ({
    statuses: [
      {
        name: 'Набор открыт',
        slug: 1,
      },
      {
        name: 'Набор закрыт',
        slug: 0
      }
    ]
  }),
  computed: {
    eventsTypes() {
      return this.$store.getters.getDictionary('events.dictionaries.eventsTypes')
    },
    modal() {
      return this.$store.getters['events/getEditFormModal']
    },
    responsibleUsers() {
      return this.$store.getters['events/getResponsibleUsers']
    },
    form() {
      return this.$store.getters['events/getEditForm']
    },
    isEventEnded() {
      return moment.tz('Europe/Moscow').format('X') > moment(this.form.dateTo, 'DD.MM.YYYY').format('X')
    }
  },
  methods: {
    close() {
      this.$store.commit('events/updateEditFormModal', {
        active: false
      })

      this.$store.commit('events/clearEditForm')
    },
    getYesterdayDate() {
      return moment(new Date()).add(-1, 'days').toDate()
    },
    createEvent() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('events/updateEditFormModal', {
            isLoading: true
          })
          this.$store.dispatch('events/create', this.form)
        }
      })
    },
    updateEvent() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('events/updateEditFormModal', {
            isLoading: true
          })
          this.$store.dispatch('events/update', {
            id: this.form.id,
            data: this.form
          })
        }
      })
    },
    typeChanged() {
      if (this.isCurrentEventType('Рекламный тур')) {
        this.$store.commit('events/setField', {
          target: 'editForm.dateFrom',
          value: moment().add(3, 'days').format('DD.MM.YYYY')
        })
      } else {
        this.$store.commit('events/setField', {
          target: 'editForm.dateFrom',
          value: ''
        })
      }
    },
    isCurrentEventType(eventName) {
      let isCurrentEvent = false

      if (this.eventsTypes.length) {
        const currentEvent = this.eventsTypes.find(item => item.name === eventName)

        isCurrentEvent = currentEvent.slug === this.$store.getters['events/getField']('editForm.typeId')
      }

      return isCurrentEvent
    }
  }
}
</script>
<template>
  <div class="card">
    <div class="events-edit-form">
      <h3 class="events-edit-form__header">
        {{
          modal.isNew
            ? 'Добавление мероприятия'
            : 'Редактирование мероприятия'
        }}
      </h3>
      <div class="events-edit-form__field events-edit-form__field--columns-1-2">
        <rex-select
          label="Тип"
          name="typeId"
          store-module="events"
          target="editForm.typeId"
          :options="eventsTypes"
          :is-disabled="!modal.isNew || modal.isLoading"
          :validate="{
            required: true
          }"
          @change="typeChanged"
        />
        <rex-input
          label="Название"
          name="name"
          store-module="events"
          target="editForm.name"
          :is-disabled="modal.isLoading"
          :validate="{
            required: true,
            max: 200
          }"
        />
      </div>
      <div class="events-edit-form__field events-edit-form__field--text">
        <rex-editor
          label="Программа"
          name="program"
          store-module="events"
          target="editForm.program"
          :is-disabled="modal.isLoading"
          :validate="{
            required: true,
            max: 2000
          }"
        />
      </div>
      <div class="events-edit-form__field">
        <rex-input
          label="Описание"
          name="description"
          store-module="events"
          getter-name="getField"
          setter-name="setField"
          target="editForm.description"
          type="textarea"
          :is-disabled="modal.isLoading"
          :validate="{
            required: true,
            max: 1000
          }"
        />
      </div>
      <div class="events-edit-form__field events-edit-form__field--columns-3">
        <rex-input
          v-if="!isCurrentEventType('Вебинар')"
          :label="isCurrentEventType('Рекламный тур') ? 'Город вылета' : 'Город'"
          name="city"
          store-module="events"
          target="editForm.city"
          :is-disabled="modal.isLoading"
          :validate="{
            required: true,
            max: 25
          }"
        />
        <rex-date
          v-if="isCurrentEventType('Рекламный тур')"
          key="eventDates"
          name="dateFrom"
          label="Даты проведения"
          store-module="events"
          target="editForm"
          :is-ranged="true"
          position="is-top-left"
          :min-date="getYesterdayDate()"
          :range-targets="['dateFrom', 'dateTo']"
          :is-disabled="modal.isLoading"
        />
        <rex-date
          v-else
          key="eventDate"
          label="Дата проведения"
          name="dateTo"
          store-module="events"
          target="editForm.dateTo"
          position="is-top-right"
          :min-date="getYesterdayDate()"
          :is-disabled="modal.isLoading"
        />
        <rex-time
          v-if="!isCurrentEventType('Рекламный тур')"
          label="Время"
          name="time"
          store-module="events"
          target="editForm.time"
          :is-disabled="modal.isLoading"
        />
        <rex-input
          v-if="!isCurrentEventType('Мероприятие')"
          label="Цена"
          name="price"
          store-module="events"
          target="editForm.price"
          :is-disabled="modal.isLoading"
          :validate="{
            required: true,
            max: 50
          }"
        />
      </div>
      <div
        class="events-edit-form__field"
        :class="{
          'events-edit-form__field--columns-3': isCurrentEventType('Мероприятие'),
          'events-edit-form__field--columns-2-1': !isCurrentEventType('Мероприятие'),
        }"
      >
        <rex-input
          v-if="isCurrentEventType('Мероприятие')"
          label="Цена"
          name="eventPrice"
          store-module="events"
          target="editForm.price"
          :is-disabled="modal.isLoading"
          :validate="{
            required: true,
            max: 50
          }"
        />
        <rex-select
          label="Получатель запросов"
          name="bitrixUserId"
          store-module="events"
          target="editForm.bitrixUserId"
          :hide-if-empty="false"
          :validate="{
            required: true
          }"
          :options="responsibleUsers"
          :is-disabled="modal.isLoading"
        />
        <rex-select
          label="Статус"
          name="status"
          store-module="events"
          target="editForm.status"
          :options="statuses"
          :is-disabled="modal.isLoading"
        />
      </div>
      <div
        v-if="!modal.isNew"
        class="events-edit-form__field"
      >
        <rex-input
          label="Ссылка на отчет"
          name="report"
          store-module="events"
          target="editForm.report"
          :is-disabled="!isEventEnded || modal.isLoading"
          :placeholder="isEventEnded
            ? null
            : 'Ссылку на отчет можно добавить после завершения мероприятия'
          "
          :validate="{
            url: true,
            max: 256
          }"
        />
      </div>
      <div class="events-edit-form__actions">
        <b-button
          class="rex-button2"
          type="is-light"
          outlined
          :disabled="modal.isLoading"
          @click="close"
        >
          Отмена
        </b-button>
        <b-button
          v-if="modal.isNew"
          class="rex-button2"
          type="is-primary"
          :disabled="modal.isLoading"
          :loading="modal.isLoading"
          @click="createEvent"
        >
          Создать
        </b-button>
        <b-button
          v-else
          class="rex-button2"
          type="is-primary"
          :disabled="modal.isLoading"
          :loading="modal.isLoading"
          @click="updateEvent"
        >
          Сохранить изменения
        </b-button>
      </div>
    </div>
  </div>
</template>